import { Box } from 'components/elements'
import { ShimmerCss } from './ListShimmer'

export const ButtonShimmer = () => {
  return (
    <Box
      css={{
        ...ShimmerCss,
        ...ButtonItemCss,
        mr: '$space$10',
        borderRadius: '$sm',
      }}
    ></Box>
  )
}

const ButtonItemCss = {
  width: 120,
  height: 40,
}
